/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseImportOldMessageResult } from '../models/api-response-import-old-message-result';
import { ApiResponseString } from '../models/api-response-string';
import { ApiResponseThreadResult } from '../models/api-response-thread-result';
import { importChatHistory } from '../fn/conversation-import-api/import-chat-history';
import { ImportChatHistory$Params } from '../fn/conversation-import-api/import-chat-history';
import { importOldMessages } from '../fn/conversation-import-api/import-old-messages';
import { ImportOldMessages$Params } from '../fn/conversation-import-api/import-old-messages';
import { storeChatMedia } from '../fn/conversation-import-api/store-chat-media';
import { StoreChatMedia$Params } from '../fn/conversation-import-api/store-chat-media';

@Injectable({ providedIn: 'root' })
export class ConversationImportApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `importChatHistory()` */
  static readonly ImportChatHistoryPath = '/v1/api/ui/conversation/history';

  /**
   * One exported chat (or one part of a long one); messages already in the conversation are skipped.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importChatHistory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importChatHistory$Response(params: ImportChatHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseThreadResult>> {
    return importChatHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * One exported chat (or one part of a long one); messages already in the conversation are skipped.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importChatHistory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importChatHistory(params: ImportChatHistory$Params, context?: HttpContext): Observable<ApiResponseThreadResult> {
    return this.importChatHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseThreadResult>): ApiResponseThreadResult => r.body)
    );
  }

  /** Path part for operation `storeChatMedia()` */
  static readonly StoreChatMediaPath = '/v1/api/ui/conversation/history/media';

  /**
   * A photo, voice note, video or document of an exported chat; answers its link.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeChatMedia()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  storeChatMedia$Response(params?: StoreChatMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return storeChatMedia(this.http, this.rootUrl, params, context);
  }

  /**
   * A photo, voice note, video or document of an exported chat; answers its link.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeChatMedia$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  storeChatMedia(params?: StoreChatMedia$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.storeChatMedia$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

  /** Path part for operation `importOldMessages()` */
  static readonly ImportOldMessagesPath = '/v1/api/ui/conversation/import-old-messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importOldMessages()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importOldMessages$Response(params: ImportOldMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportOldMessageResult>> {
    return importOldMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importOldMessages$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importOldMessages(params: ImportOldMessages$Params, context?: HttpContext): Observable<ApiResponseImportOldMessageResult> {
    return this.importOldMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportOldMessageResult>): ApiResponseImportOldMessageResult => r.body)
    );
  }

}
